export const categories = [
  { slug: 'wanghong-tafang', name: '网红塌房', icon: 'ri-user-unfollow-line', description: '网红圈塌房现场第一时间直击' },
  { slug: 'mingxing-heiliao', name: '明星黑料', icon: 'ri-star-line', description: '娱乐圈明星最新黑料爆料' },
  { slug: 'chigua-dasai', name: '吃瓜大赛', icon: 'ri-emotion-happy-line', description: '年度最劲爆吃瓜事件评选' },
  { slug: 'bagua-shendu', name: '八卦深度', icon: 'ri-search-eye-line', description: '深度挖掘八卦背后的真相' },
  { slug: 'zhibo-fancheshijian', name: '直播翻车', icon: 'ri-live-line', description: '直播带货翻车名场面合集' },
  { slug: 'zongyi-guazhonggua', name: '综艺瓜中瓜', icon: 'ri-tv-line', description: '综艺节目台前幕后的秘密' },
];

export const heroArticles = [
  {
    slug: 'dingji-wanghong-beihou-ziben-jiaoyi',
    title: '顶流网红背后资本交易全曝光，千万粉丝账号实为傀儡',
    summary: '某平台粉丝破千万的顶流网红被曝所有内容均由MCN机构操控，真实身份成谜，日入百万背后是精心设计的骗局。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageSeq: 'hero-article-01',
    imageQuery: 'Dramatic dark abstract ink splash background with deep red and black tones, mysterious atmosphere, entertainment gossip news portal style, artistic blur effect, high contrast, moody and intense, wide banner composition with negative space for text overlay',
    views: 128390,
    comments: 3456,
    date: '2026-07-06',
    hot: true,
  },
  {
    slug: 'danghong-nvxing-taoshuilou-jiyi',
    title: '当红女星被曝税务漏洞高达八位数，工作室连夜发声明',
    summary: '据知情人士透露，该女星三年内通过阴阳合同、虚假发票等手段累计逃税超过3000万元。',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    imageSeq: 'hero-article-02',
    imageQuery: 'Dark red abstract artistic background with flowing ink texture, dramatic lighting, entertainment news visual style, sophisticated and mysterious mood, high-end magazine editorial aesthetic, deep crimson and black tones',
    views: 98520,
    comments: 2891,
    date: '2026-07-05',
    hot: true,
  },
  {
    slug: 'zhiming-zhubo-zhibo-jian-bei-jubao',
    title: '知名主播直播带货假货被当场举报，场面一度失控',
    summary: '该主播在直播间销售所谓"原单大牌"被职业打假人当场揭穿，直播间在线人数从10万瞬间飙升至50万。',
    category: '直播翻车',
    categorySlug: 'zhibo-fancheshijian',
    imageSeq: 'hero-article-03',
    imageQuery: 'Dramatic dark abstract composition with crimson and black ink wash effect, intense contrasting tones, news media aesthetic, mysterious and bold atmosphere, wide cinematic background for headline overlay',
    views: 75680,
    comments: 2134,
    date: '2026-07-04',
    hot: true,
  },
];

export const hotArticles = [
  {
    slug: 'ai-huansheng-jishu-bei-yongyu-zaoyao',
    title: 'AI换脸技术被用于造谣明星出轨，幕后黑手竟是前经纪人',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20beige%20minimalist%20abstract%20background%20with%20soft%20dark%20gray%20gradient%20clean%20editorial%20photography%20style%20subtle%20texture%20neutral%20modern%20aesthetic%20elegant%20composition%20for%20news%20card%20thumbnail%20understated%20and%20refined%20atmosphere&width=640&height=400&seq=hot-article-01&orientation=landscape',
    views: 89340,
    date: '2026-07-06',
  },
  {
    slug: 'duan-shipin-wanghong-bei-bao-xiedu-juben',
    title: '短视频网红被曝所有内容均有编剧团队，真实人设彻底崩塌',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20beige%20and%20dark%20gray%20abstract%20gradient%20background%20soft%20atmospheric%20tone%20minimalist%20editorial%20style%20subtle%20texture%20clean%20and%20modern%20composition%20for%20content%20card%20neutral%20aesthetic&width=640&height=400&seq=hot-article-02&orientation=landscape',
    views: 76450,
    date: '2026-07-05',
  },
  {
    slug: 'dingjian-yiren-jieru-daobi-qian-bei',
    title: '顶流艺人被曝借高利贷赌博，欠款金额触目惊心',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Subtle%20warm%20beige%20abstract%20background%20with%20dark%20gray%20gradient%20accents%20clean%20minimalist%20composition%20editorial%20magazine%20style%20soft%20elegant%20tones%20neutral%20aesthetic%20for%20news%20thumbnail&width=640&height=400&seq=hot-article-03&orientation=landscape',
    views: 67230,
    date: '2026-07-05',
  },
  {
    slug: 'zongyi-jie-zui-da-heimu-jiekai',
    title: '综艺界最大黑幕揭开：选秀排名全由资本决定',
    category: '综艺瓜中瓜',
    categorySlug: 'zongyi-guazhonggua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20beige%20and%20dark%20gray%20abstract%20gradient%20soft%20atmospheric%20minimalist%20style%20clean%20editorial%20composition%20subtle%20texture%20neutral%20modern%20aesthetic%20for%20content%20thumbnail%20card&width=640&height=400&seq=hot-article-04&orientation=landscape',
    views: 59100,
    date: '2026-07-04',
  },
  {
    slug: 'zhiming-zhuchiren-bei-bao-qian-guize',
    title: '知名主持人被曝潜规则女嘉宾，多名受害者联合发声',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20gray%20and%20warm%20beige%20abstract%20gradient%20background%20soft%20subtle%20texture%20minimalist%20editorial%20photography%20style%20clean%20modern%20composition%20neutral%20calm%20aesthetic%20for%20news%20card&width=640&height=400&seq=hot-article-05&orientation=landscape',
    views: 54890,
    date: '2026-07-04',
  },
  {
    slug: 'daihuo-yi-ge-shangpin-jingran-shi',
    title: '带货一哥被曝商品竟然是自己工厂产的贴牌货',
    category: '直播翻车',
    categorySlug: 'zhibo-fancheshijian',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20beige%20abstract%20background%20with%20dark%20gray%20tones%20soft%20gradient%20clean%20editorial%20style%20subtle%20texture%20neutral%20and%20modern%20aesthetic%20for%20thumbnail%20card&width=640&height=400&seq=hot-article-06&orientation=landscape',
    views: 48320,
    date: '2026-07-03',
  },
];

export const editorPicks = [
  {
    slug: 'sanda-wanghong-jiti-bengta-jiexi',
    title: '三大网红集体崩塌深度解析：流量泡沫终将破灭',
    summary: '深入分析近期三大网红塌房事件背后的共同特征和行业警示。',
    imageSeq: 'editor-pick-01',
    imageQuery: 'Dramatic abstract composition with warm beige base and deep red accent tones, bold editorial style, sophisticated atmosphere, high-end magazine layout aesthetic, striking visual impact',
    date: '2026-07-06',
  },
  {
    slug: 'mcn-jigou-neimu-jiekai-zhenxiang',
    title: 'MCN机构内幕揭开：你的偶像都是流水线产品',
    summary: '揭秘国内头部MCN机构如何批量制造网红，从人设到内容全流程操控。',
    imageSeq: 'editor-pick-02',
    imageQuery: 'Dark abstract background with warm beige and crimson accents, bold editorial composition, sophisticated magazine style, dramatic lighting effect, artistic and modern aesthetic',
    date: '2026-07-05',
  },
  {
    slug: 'chigua-qunzhong-shengcun-zhinan',
    title: '吃瓜群众生存指南：如何辨别真假爆料信息',
    summary: '资深娱记教你从细节判断爆料的真实性，不再被虚假信息牵着走。',
    imageSeq: 'editor-pick-03',
    imageQuery: 'Warm beige abstract background with dark and red accent tones, editorial magazine composition, sophisticated clean style, modern artistic aesthetic, striking visual layout',
    date: '2026-07-04',
  },
];

export const comments = [
  {
    id: 1,
    user: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20abstract%20avatar%20in%20warm%20beige%20and%20dark%20gray%20tones%2C%20simple%20clean%20composition%2C%20soft%20lighting%2C%20modern%20editorial%20aesthetic%2C%20neutral%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    title: '终于有人爆料了，等这一天等了好久！',
    content: '这个圈子真的水太深了，表面光鲜亮丽，背地里全是交易。希望有关部门能好好查一查，给消费者一个交代。作为老粉真的寒心。',
    date: '2026-07-06',
  },
  {
    id: 2,
    user: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20in%20warm%20tones%2C%20simple%20clean%20composition%2C%20soft%20warm%20lighting%2C%20modern%20editorial%20style%2C%20neutral%20and%20calm%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 4,
    title: '信息量很大，建议出个完整时间线',
    content: '每一条都挺劲爆的，但希望能出一个完整的时间线梳理，这样大家看得更清楚。小编辛苦了，期待后续更多细节。',
    date: '2026-07-06',
  },
  {
    id: 3,
    user: '娱乐圈纪检委',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20in%20dark%20gray%20and%20warm%20tones%2C%20clean%20simple%20composition%2C%20soft%20lighting%2C%20modern%20editorial%20aesthetic%2C%20confident%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 5,
    title: '每日黑料yyds，全网最快爆料平台',
    content: '我对比了好几个平台，每日黑料的爆料速度真的是最快的，而且准确率也很高。已经推荐给身边所有爱吃瓜的朋友了！',
    date: '2026-07-05',
  },
  {
    id: 4,
    user: '瓜田里的猹',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20in%20soft%20beige%20tones%2C%20simple%20clean%20composition%2C%20warm%20lighting%2C%20modern%20editorial%20style%2C%20playful%20subtle%20expression&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 5,
    title: '这个瓜我吃了，真香！',
    content: '每天打开每日黑料已经成习惯了，跟追剧一样。小编团队真的太牛了，总能挖到别人挖不到的料。希望继续保持这个节奏！',
    date: '2026-07-05',
  },
  {
    id: 5,
    user: '真相只有一个',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20in%20dark%20warm%20tones%2C%20clean%20simple%20composition%2C%20soft%20lighting%2C%20modern%20editorial%20aesthetic%2C%20serious%20thoughtful%20expression&width=80&height=80&seq=avatar-05&orientation=squarish',
    rating: 4,
    title: '建议增加证据链展示功能',
    content: '爆料内容很精彩，但如果能把证据链展示得更清晰就更好了。比如聊天记录截图、转账记录等，让大家看得更明白。',
    date: '2026-07-04',
  },
  {
    id: 6,
    user: '资深吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20in%20warm%20beige%20tones%2C%20simple%20clean%20composition%2C%20soft%20lighting%2C%20modern%20editorial%20aesthetic%2C%20friendly%20warm%20expression&width=80&height=80&seq=avatar-06&orientation=squarish',
    rating: 5,
    title: '连续签到第30天，忠实粉丝报道',
    content: '从每日黑料上线第一天就在追了，内容质量一直很高，从不标题党。希望平台越来越好，成为全网最权威的娱乐爆料平台。',
    date: '2026-07-04',
  },
];

export const stats = [
  { value: '12,850', suffix: '+', label: '累计爆料' },
  { value: '3,200', suffix: '+', label: '已验证爆料' },
  { value: '98.6', suffix: '%', label: '准确率' },
  { value: '580', suffix: '万+', label: '月活用户' },
];